"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Barchart;
var _react = _interopRequireWildcard(require("react"));
var _chartsReact = require("@carbon/charts-react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _util = require("./util");
var _useBreakPoint = require("../../../common/useBreakPoint");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.sia-barchart-container {\n  width: 100%;\n  height: 100%;\n  max-width: 1056px;\n  box-sizing: border-box; }\n  .sia-barchart-container .cds--cc--axes g.axis.bottom g.tick text {\n    font-family: 'Helvetica Neue LT Roman';\n    font-size: 12px;\n    color: #000000; }\n  .sia-barchart-container .cds--cc--axes g.axis.left g.tick text {\n    font-family: 'Helvetica Neue LT Roman';\n    font-size: 16px;\n    color: #000000; }\n  .sia-barchart-container div.cds--cc--legend div.legend-item p {\n    font-size: 16px; }\n  .sia-barchart-container .ticks .tick text {\n    transform-box: fill-box; }\n  .sia-barchart-container .checkbox {\n    margin-bottom: 0; }\n  @media (max-width: 1055px) {\n    .sia-barchart-container {\n      max-width: 100%;\n      width: 100%;\n      overflow: hidden; } }\n  @media (max-width: 671px) {\n    .sia-barchart-container {\n      max-width: 100%;\n      width: 100%;\n      overflow: hidden; }\n    .sia-barchart-container .legend {\n      padding-top: 16px; }\n    .sia-barchart-container div.cds--cc--legend {\n      margin-left: 0 !important; }\n    .sia-barchart-container .cds--cc--axes g.axis.bottom g.tick text {\n      font-size: 14px; } }\n";
  const fileName = "Barchart_Barchart";
  const element = document.querySelector("style[data-sass-component='Barchart_Barchart']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
function Barchart(_ref) {
  let {
    data,
    options,
    bandWidth,
    translate
  } = _ref;
  const ref = (0, _react.useRef)(null);
  const [chartRef, setChartRef] = (0, _react.useState)(null);
  const {
    isMobile,
    width
  } = (0, _useBreakPoint.useBreakPoint)();
  (0, _react.useEffect)(() => {
    if (ref.current) {
      let chartRef = ref.current.chartRef.current;
      setChartRef(chartRef);
    }
  }, [bandWidth, translate]);
  (0, _react.useLayoutEffect)(() => {
    if (chartRef) {
      (0, _util.alignLegends)(chartRef);
      let renderCompleteListener = () => {
        if (isMobile) {
          (0, _util.rotateBottomTicks)(chartRef);
        }
      };
      let events = ref.current.chart.services.events;
      events.addEventListener('axis-render-complete', renderCompleteListener);
      return () => events.removeEventListener('axis-render-complete', renderCompleteListener);
    }
  }, [chartRef, isMobile]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "sia-barchart-container sia-padding-02-left sia-padding-03-right"
  }, /*#__PURE__*/_react.default.createElement(_chartsReact.GroupedBarChart, {
    ref: ref,
    data: data,
    options: (0, _util.getOptions)({
      ...options,
      height: (0, _util.getComputedHeight)(chartRef, bandWidth, data, 2)
    }, translate, isMobile, width)
  }));
}
Barchart.proTypes = {
  data: _propTypes.default.arrayOf(_propTypes.default.shape({
    key: _propTypes.default.string,
    value: _propTypes.default.number,
    group: _propTypes.default.string
  })).isRequired,
  options: _propTypes.default.shape({}),
  transalte: _propTypes.default.func.isRequired,
  bandWidth: _propTypes.default.number
};